import { Component } from '@angular/core';

@Component({
  selector: 'ui-card-body',
  templateUrl: './card-body.component.html',
  styleUrls: ['./card-body.component.scss'],
})
export class CardBodyComponent {}
